<template>
  <div class="upload-section">
    <div class="preloaded-gallery" aria-label="preloaded example images for user study">
      <div v-for="(group, gIdx) in groupedImages"
          :key="group.groupName"
          class="unit-block">
        <h2 class="section-title">
          <span class="bar"></span>
          {{ group.groupName }}
        </h2>

        <div v-for="unit in group.units"
            :key="unit.unitName"
            class="unit-section">

          <div class="unit-header">
            <h3 class="unit-label">
              {{ unit.unitName }}
            </h3>
            <span class="unit-count">
              {{ unit.images.length }} items
            </span>
          </div>

          <div class="gallery-grid">
            <button
              v-for="img in unit.images"
              :key="img.id"
              class="image-card"
              :aria-label="'image ' + img.name + ' select for analysis'"
              @click="viewImageDetail(img)"
            >
              <div class="thumb">
                <img :src="img.file" :alt="img.name" class="gallery-image">
              </div>

              <div class="card-meta">
                <div class="image-title">
                  {{ img.name }}
                </div>
              </div>

              <div class="view-detail-overlay">
                <span>Click to Analyze</span>
              </div>

            </button>
          </div>

        </div>

        <div v-if="gIdx !== groupedImages.length - 1"
            class="unit-divider"></div>

      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'UploadSection',
  data() {
    return {
      uploadedImages: [],

      // 폴더별 변수 선언
      barGraphImages: [],
      lineGraphImages: [],
      pieChartImages: [],
      scatterplotImages: [],
      poc6Images: [],
      poc7Images: [],
      firstSemester: {},
      secondSemester: {},
      dynamicGroups: {}
    };
  },
  mounted() {
    this.loadPreloadedImages();
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
    
    firstSemesterGroups() {
      return this.makeUnitGroups(this.firstSemester)
    },
    secondSemesterGroups() {
      return this.makeUnitGroups(this.secondSemester)
    },
groupedImages() {
  return Object.entries(this.dynamicGroups).map(
    ([semester, units]) => ({
      groupName: semester,
      units: Object.entries(units).map(
        ([unitName, images]) => ({
          unitName,
          images
        })
      )
    })
  );
}

  },
  watch: {
  currentLanguage() {
    // 1️⃣ 기존 데이터 초기화
    this.dynamicGroups = {};

    // 2️⃣ 다시 로딩
    this.loadPreloadedImages();
  }
},

  methods: {
async loadPreloadedImages() {
  this.dynamicGroups = {};

  const allContext = require.context(
    '@/assets/user_study',
    true,
    /\.(png|jpe?g|gif)$/
  );

  for (const [idx, key] of allContext.keys().entries()) {

    const pathParts = key.replace(/^\.\//, '').split('/');

    const lang = pathParts[0];
    if (lang !== this.currentLanguage) continue;

    const semester = pathParts[1];
    const unit = pathParts.length >= 4 ? pathParts[2] : '';

    const name = pathParts[pathParts.length - 1].replace(/\.[^/.]+$/, '');
    const fileUrl = allContext(key);
    const base64 = await this.convertImageToBase64(fileUrl);

    if (!this.dynamicGroups[semester]) {
      this.dynamicGroups[semester] = {};
    }

    if (!this.dynamicGroups[semester][unit]) {
      this.dynamicGroups[semester][unit] = [];
    }

    this.dynamicGroups[semester][unit].push({
      id: `preloaded_${idx}`,
      file: base64,
      name,
      unit
    });
  }
}
,


    async convertImageToBase64(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileSelect(event) {
      this.processFiles(event.target.files);
    },

    handleDrop(event) {
      event.preventDefault();
      this.processFiles(event.dataTransfer.files);
    },

    processFiles(files) {
      Array.from(files).forEach(file => {
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const imageData = {
              objectType: 'Image',
              id: `img_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
              rId: `rId${Date.now()}`,
              file: e.target.result,
              analyzed: '',
              originalFile: file,
              name: file.name,
              size: file.size,
              type: file.type,
              uploadedAt: new Date().toISOString(),
              isUploaded: false,
              isAnalyzed: false,
              uploadProgress: 0
            };
            this.uploadedImages.push(imageData);
          };
          reader.readAsDataURL(file);
        }
      });
    },

    removeImage(index) {
      this.uploadedImages.splice(index, 1);
    },

    clearAllImages() {
      this.uploadedImages = [];
    },

    viewImageDetail(image) {
      this.$emit('image-uploaded', image);
    },

    makeUnitGroups(semesterObj) {
      const entries = Object.entries(semesterObj || {});

      const sorted = entries.sort(([a], [b]) => this.getUnitNumber(a) - this.getUnitNumber(b));
      return sorted.map(([unitName, images]) => ({
        unitName,
        images,
      }));
    },

    getUnitNumber(unitName) {
      const m = String(unitName).match(/(\d+)/);
      return m ? parseInt(m[1], 10) : Number.MAX_SAFE_INTEGER;
    }
  }
};

</script>

<style scoped>
.section-title {
  font-size: 24px;
  font-weight: 700;
  padding-top: 16px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title .bar {
  width: 4px;
  height: 18px;
  background: #f97316;
  border-radius: 2px;
}

.upload-section {
  /*width: 100vw;
  max-width: none;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  */
  background: white;
  /*border-radius: 15px;*/
  padding: 2rem;
  margin-bottom: 2rem;
  /*box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); */
  font-size: 20px;
}

.upload-section h1 {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #2c3e50;
  font-size: 35px;
}
.upload-section h2 {
  text-align: left;
  margin-bottom: 1.5rem;
  color: #2c3e50;
}

.upload-area {
  border: 3px dashed #3498db;
  border-radius: 10px;
  padding: 3rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.upload-area:hover {
  border-color: #2980b9;
  background: #e3f2fd;
}

.upload-placeholder {
  color: #7f8c8d;
}

.upload-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.upload-hint {
  font-size: 0.9rem;
  margin-top: 0.5rem;
  font-style: italic;
}

.image-gallery {
  margin-top: 2rem;
}

.image-gallery h3 {
  margin-bottom: 1rem;
  color: #2c3e50;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 22px;
  margin-bottom: 24px;
}

.unit-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.unit-label {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
}

.unit-count {
  font-size: 13px;
  background: #f97316;
  color: white;
  padding: 4px 10px;
  border-radius: 999px;
}

.unit-divider {
  height: 1px;
  background: #E5E7EB;
  margin: 40px 0;
}

/* image-card, hover, thumb 추가 */
.image-card {
  position: relative;
  width: 238px;
  height: 350px;
  
  padding: 16px;
  box-sizing: border-box;
  border-radius: 20px;
  background: #fff;
  border: 1px solid #F0F0F0;
  box-shadow: 0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A;

  cursor: pointer;
  transition: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.25s ease;
}

.image-card:focus {
  position: relative;
  width: 238px;
  height: 350px;

  padding: 16px;
  box-sizing: border-box;
  border-radius: 20px;
  background: #fff;
  border: 1px solid #F0F0F0;
  box-shadow: 0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A;

  cursor: pointer;
  transition: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.25s ease;
}

.image-card:focus {
  position: relative;
  width: 238px;
  height: 350px;

  padding: 16px;
  box-sizing: border-box;
  border-radius: 20px;
  background: #fff;
  border: 1px solid #F0F0F0;
  box-shadow: 0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A;

  cursor: pointer;
  transition: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.25s ease;
}



.thumb {
  position: relative;
  padding-top: 16px;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #F7F7F7;
  border: 1px solid #F0F0F0;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.thumb .gallery-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.image-item {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.image-item:hover {
  transform: translateY(-5px);
}

.image-item:hover .view-detail-overlay {
  opacity: 1;
}

.gallery-image {
  height: auto;
}

.card-meta {
  padding: 16px 16px 16px;
  margin-top: 24px;
}

.unit-title {
  font-size: 18px;
  font-weight: 700;
  color: #44403F;
  line-height: 1.2;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-title {
  text-align: left;
  font-size: 12px;
  font-weight: 400;
  color: #AAABAB;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* overlay는 이미지 위에서만 보이게 */
.view-detail-overlay {
  position: absolute;
  inset: 0;
  background: rgba(234, 84, 20, 0.7);
  border: 3px solid #EA5414;
  border-radius: 20px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
  font-weight: 700;
  font-size: 32px;
  text-align: center;
}

.image-card:hover .view-detail-overlay,
.image-card:focus .view-detail-overlay {
  opacity: 1;
}

.image-info {
  padding: 0.5rem;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.image-name {
  font-size: 0.8rem;
  color: #555;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-status {
  display: flex;
  gap: 0.25rem;
  margin: 0 0.5rem;
}
.unit-section {
  background: #f9fafb;
  border-radius: 18px;
  padding: 30px;
  margin-bottom: 40px;
  transition: all 0.2s ease;
}



.status-badge {
  font-size: 0.8rem;
  padding: 0.1rem 0.3rem;
  border-radius: 10px;
  background: #f8f9fa;
}

.status-badge.uploaded {
  background: #d4edda;
  color: #155724;
}

.status-badge.analyzed {
  background: #e2e3f7;
  color: #383d41;
}

.remove-btn {
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: background 0.3s ease;
}

.remove-btn:hover {
  background: #c0392b;
}

.clear-btn {
  background: #e74c3c;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.3s ease;
}

.clear-btn:hover {
  background: #c0392b;
}
.unit-block {
  background: #ffffff;
  border-radius: 24px;
  padding: 40px;
  margin-bottom: 60px;
}


@media (max-width: 768px) {
  .upload-area {
    padding: 2rem 1rem;
  }
  
  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
}
</style>
